import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer>
      <p>&copy; 2024 Support System</p>
    </footer>
  );
};

export default Footer;
